import { Box, Card, styled } from '@mui/material';

export const MainHome = styled(Box)(({ theme }) => ({
    backgroundColor: theme.colors.white,
    '.app-btn': {
        width: '12rem',
        backgroundColor: theme.colors.black,
        margin: `0 ${theme.spacing(2)}`,
        border: `0.063rem solid ${theme.colors.black}`,
        '&:hover': {
            borderColor: 'transparent',
        },
        [theme.breakpoints.down('lg')]: {
            width: '11rem',
            margin: `0 ${theme.spacing(1.5)}`,
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: '0',
            marginRight: '0',
            marginTop: theme.spacing(3),
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        },
    },
    '.home-title': {
        fontSize: '3rem',
        lineHeight: '3rem',
        [theme.breakpoints.down('lg')]: {
            fontSize: '2.125rem',
            lineHeight: '2.125rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.875rem',
            lineHeight: '1.875rem',
        }
    }
}));

export const BannerSection = styled(Box)(({ theme }) => ({
    backgroundImage: `url(${process.env.NEXT_PUBLIC_IMAGE_URL}/nxc-landing-bg.jpg)`,
    backgroundColor: theme.colors.blue,
    position: 'relative',
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
        backgroundImage: `url(${process.env.NEXT_PUBLIC_IMAGE_URL}/nxc-landing-mobile-bg.png)`,
        backgroundPosition: 'top',
    },
    '.home-header': {
        position: 'relative',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: `${theme.spacing(3.75)} ${theme.spacing(3.75)}`,
        [theme.breakpoints.down('lg')]: {
            padding: `${theme.spacing(2.5)} ${theme.spacing(2.5)}`,
        },
        'svg': {
            [theme.breakpoints.down('lg')]: {
                width: '7.5rem',
            },
        }
    },
    '.box-center': {
        position: 'relative',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: `${theme.spacing(21.25)} 0 ${theme.spacing(25)}`,
        [theme.breakpoints.down('xl')]: {
            padding: `${theme.spacing(12.5)} 0 ${theme.spacing(15)}`,
        },
    },
    '.home-banner-text': {
        width: '60%',
        textAlign: 'center',
        [theme.breakpoints.down('lg')]: {
            width: '50%',
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            padding: `${theme.spacing(7)} 0 0`,
        },
        '.tag-line-text': {
            color: theme.colors.brown,
            fontSize: '1.375rem',
            fontWeight: '600',
            textTransform: 'uppercase',
            marginBottom: theme.spacing(1.5),
            letterSpacing: '0.08rem',
            [theme.breakpoints.down('md')]: {
                fontSize: '1rem',
                marginBottom: theme.spacing(1),
            },
        },
        '.banner-main-text': {
            fontSize: '4.25rem',
            lineHeight: '4.375rem',
            color: theme.colors.white,
            fontWeight: '700',
            [theme.breakpoints.down('lg')]: {
                fontSize: '2.875rem',
                lineHeight: '3.25rem',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '2.25rem',
                lineHeight: '2.625rem',
            }
        },
        '.description-text': {
            fontSize: '1.25rem',
            color: theme.colors.white,
            marginTop: theme.spacing(4),
            lineHeight: '1.875rem',
            fontWeight: '400',
            [theme.breakpoints.down('lg')]: {
                fontSize: '1rem',
                marginTop: theme.spacing(1.5),
            },
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(1),
                lineHeight: `1.5rem`
            }
        },
        '.app-btn-section': {
            position: 'relative',
            marginTop: theme.spacing(10),
            [theme.breakpoints.down('lg')]: {
                marginTop: theme.spacing(4),
            },
            '.download-text': {
                fontSize: '1.25rem',
                color: theme.colors.white,
                marginBottom: theme.spacing(2),
                fontWeight: '500',
                [theme.breakpoints.down('lg')]: {
                    fontSize: '1rem',
                    marginBottom: theme.spacing(1.2),
                },
                [theme.breakpoints.down('sm')]: {
                    marginBottom: theme.spacing(0),
                },
            },
            '.app-btn-box': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                [theme.breakpoints.down('lg')]: {
                    flexWrap: 'wrap',
                    width: '100%',
                    opacity: '0',
                    position: 'absolute',
                    zIndex: '-15'
                },
                '.app-btn': {
                    '&:hover': {
                        borderColor: theme.colors.white,
                    },
                    [theme.breakpoints.down('sm')]: {
                        width: '100%',
                        margin: `${theme.spacing(2)} 0 0 0`
                    },
                }
            },
            '.mobile-app-btn-box': {
                display: 'none',
                [theme.breakpoints.down('lg')]: {
                    display: 'block'
                },
            }
        }
    }
}));

export const FeatureSection = styled(Box)(({ theme }) => ({
    position: 'relative',
    padding: `${theme.spacing(18.75)} 0px`,
    [theme.breakpoints.down('lg')]: {
        padding: `${theme.spacing(12.5)} 0px`,
    },
    [theme.breakpoints.down('sm')]: {
        padding: `${theme.spacing(7.5)} 0px`,
    },
    '&.space-zero': {
        padding: `0px 0px`,
    },
    '.box-center': {
        position: 'relative',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            paddingBottom: `${theme.spacing(4)}`,
        },
    },
    '.feature-text': {
        '&.athletes-text': {
            position: 'relative',
            marginTop: theme.spacing(8.75),
            marginRight: theme.spacing(-7.5),
            [theme.breakpoints.down('md')]: {
                marginTop: theme.spacing(0),
                marginRight: theme.spacing(0),
            }
        },
        '&.space-top': {
            marginTop: theme.spacing(8.75),
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(0)
            }
        }
    },
    '.feature-title': {
        marginBottom: theme.spacing(3.5),
        color: theme.colors.black,
        [theme.breakpoints.down('lg')]: {
            marginBottom: theme.spacing(3),
        }
    },
    '.feature-details': {
        fontSize: '1.125rem',
        color: theme.colors.neutral925,
        'span': {
            display: 'block'
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: '1rem',
        },
        '&.influencers-details': {
            paddingRight: '6.25rem',
            [theme.breakpoints.down('md')]: {
                paddingRight: '0rem',
            },
        }
    },
    '.feature-img': {
        position: 'relative',
        '.img-fluid': {
            maxWidth: '100%'
        },
        '&.influencers-img': {
            marginLeft: '-1.875rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '0rem',
            },
        }
    },
    '.order-img-panel': {
        [theme.breakpoints.down('sm')]: {
            order: '1'
        }
    },
    '.order-text-panel': {
        [theme.breakpoints.down('sm')]: {
            order: '0'
        }
    }
}));

export const AppBannerSection = styled(Box)(({ theme }) => ({
    backgroundImage: `url(${process.env.NEXT_PUBLIC_IMAGE_URL}/nxc-one-link-bg.png)`,
    position: 'relative',
    padding: `${theme.spacing(18.75)} 0px`,
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
    [theme.breakpoints.down('lg')]: {
        padding: `${theme.spacing(12.5)} 0px`,
    },
    '.link-section-text': {
        position: 'relative',
        width: '80%',
        margin: '0 auto',
        textAlign: 'center',
        [theme.breakpoints.down('lg')]: {
            width: '60%',
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    '.link-title': {
        lineHeight: '3.75rem',
        color: theme.colors.white,
        margin: `0`,
        fontWeight: '700',
        [theme.breakpoints.down('lg')]: {
            lineHeight: '2.875rem',
        }
    },
    '.dot-space': {
        margin: `${theme.spacing(2.5)} ${theme.spacing(0)}`,
        [theme.breakpoints.down('lg')]: {
            margin: `${theme.spacing(2)} ${theme.spacing(0)}`,
        }
    },
    '.link-details': {
        fontSize: '1.125rem',
        color: theme.colors.white,
        padding: `0 ${theme.spacing(11.25)}`,
        fontWeight: '300',
        marginBottom: `${theme.spacing(10)}`,
        [theme.breakpoints.down('lg')]: {
            fontSize: '1rem',
            padding: `0 ${theme.spacing(1)}`,
            marginBottom: `${theme.spacing(5)}`,
        }
    },
    '.app-btn-box': {
        [theme.breakpoints.down('lg')]: {
            opacity: '0',
            position: 'absolute',
            zIndex: '-15',
            width: '100%'
        },
        '.app-btn': {
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                margin: `${theme.spacing(2)} 0 0 0`
            },
        }
    },
    '.mobile-app-btn-box': {
        display: 'none',
        [theme.breakpoints.down('lg')]: {
            display: 'block'
        },
    }
}));

export const CategorieSection = styled(Box)(({ theme }) => ({
    position: 'relative',
    padding: `${theme.spacing(18.75)} 0px`,
    width: '100%',
    backgroundColor: theme.colors.neutral075,
    overflow: 'hidden',
    [theme.breakpoints.down('lg')]: {
        padding: `${theme.spacing(12.5)} 0px`,
    },
    [theme.breakpoints.down('sm')]: {
        padding: `${theme.spacing(7.5)} 0px`,
    },
    '.categorie-title': {
        textAlign: 'center',
        marginBottom: theme.spacing(7),
        color: theme.colors.black,
        [theme.breakpoints.down('lg')]: {
            marginBottom: theme.spacing(4.5),
        },
        [theme.breakpoints.down('md')]: {
            marginBottom: theme.spacing(3),
        },
    },
    '&:before': {
        content: "''",
        position: 'absolute',
        width: '46.875rem',
        height: '46.875rem',
        backgroundColor: 'transparent',
        borderRadius: '50%',
        border: `13.75rem solid ${theme.colors.blueDark}`,
        opacity: '0.1',
        zIndex: '0',
        bottom: '-20rem',
        left: '-20rem'
    },
    '.nxivl-panel': {
        [theme.breakpoints.down('sm')]: {
            order: '1'
        }
    }
}));

export const CategorieCard = styled(Card)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: `${theme.spacing(4)} ${theme.spacing(4)}`,
    margin: theme.spacing(0),
    borderRadius: '1.563rem',
    backgroundColor: theme.colors.white,
    boxShadow: `0 10px 50px 0 rgba(0, 0, 0, 0.20)`,
    [theme.breakpoints.down('lg')]: {
        padding: `${theme.spacing(3)} ${theme.spacing(3)}`,
    },
    '.categorie-icon': {
        width: '4.375rem',
        height: '4.375rem',
        background: theme.colors.blue,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.spacing(1),
        [theme.breakpoints.down('lg')]: {
            width: '3.75rem',
            height: '3.75rem',
        },
        'svg': {
            width: '1.875rem'
        }
    },
    '.categorie-text': {
        fontSize: '1.25rem',
        flex: '1',
        marginLeft: theme.spacing(3.75),
        paddingRight: theme.spacing(3.75),
        color: theme.colors.black,
        [theme.breakpoints.down('lg')]: {
            fontSize: '1rem',
            marginLeft: theme.spacing(3),
        }
    },
    '&.nxivl-cat': {
        justifyContent: 'center',
        background: theme.colors.blue,
        padding: `${theme.spacing(2.25)} ${theme.spacing(4)}`,
        [theme.breakpoints.down('lg')]: {
            padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
        },
        '.img-nxivl': {
            width: '100%',
            [theme.breakpoints.down('lg')]: {
                width: '14.813rem'
            },
            [theme.breakpoints.down('md')]: {
                width: '15.125rem'
            }
        }
    }
}));

export const FooterSection = styled(Box)(({ theme }) => ({
    position: 'relative',
    backgroundColor: theme.colors.blueDark,
    padding: `${theme.spacing(11.25)} ${theme.spacing(0)}`,
    [theme.breakpoints.down('md')]: {
        padding: `${theme.spacing(7.5)} ${theme.spacing(0)} ${theme.spacing(3.75)}`,
    },
    '.footer-logo-section': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: theme.spacing(6),
        borderBottom: `0.063rem solid ${theme.colors.white}`,
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            justifyContent: 'center',
            paddingBottom: theme.spacing(4),
            marginBottom: theme.spacing(3),
        }
    },
    '.footer-btns': {
        [theme.breakpoints.down('lg')]: {
            width: '100%',
            textAlign: 'center',
            display: 'none',
            flexWrap: 'wrap'
        },
        '.app-btn': {
            marginLeft: theme.spacing(2),
            marginRight: '0',
            backgroundColor: 'transparent',
            borderColor: theme.colors.white,
            '&:hover': {
                borderColor: theme.colors.blue,
                backgroundColor: theme.colors.blue,
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                marginLeft: '0',
                marginRight: '0',
                marginTop: theme.spacing(3)
            },
        }
    },
    '.mobile-app-btn-box': {
        display: 'none',
        '&.mobile-footer-btns': {
            '.app-btn': {
                marginLeft: theme.spacing(2),
                marginRight: '0',
                backgroundColor: 'transparent',
                borderColor: theme.colors.white,
                [theme.breakpoints.down('sm')]: {
                    width: '100%',
                    marginLeft: '0',
                    marginRight: '0',
                    marginTop: theme.spacing(3)
                },
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
        [theme.breakpoints.down('lg')]: {
            display: 'block',
        },
    },
    '.copyright-panel': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        '.copyright-text': {
            fontSize: '1rem',
            color: theme.colors.white,
            fontWeight: '500',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            '.footer-link': {
                padding: `${theme.spacing(0)} ${theme.spacing(0.5)}`,
                cursor: 'pointer',
                color: theme.colors.blue,
                textDecoration: 'none',
                textTransform: 'capitalize',
            },
            [theme.breakpoints.down('md')]: {
                order: '2',
                width: '100%',
                justifyContent: 'center',
                marginTop: theme.spacing(2),
                display: 'block',
                textAlign: 'center'
            }
        },
        'svg': {
            width: '5.625rem',
            [theme.breakpoints.down('sm')]: {
                width: '5rem',
            },
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            flexWrap: 'wrap',
            justifyContent: 'center'
        }
    }
}));




